import { eventDispatcherConfig } from './CloudValuePropPage.analytics'

import { PageSuffix } from '@/constants/errors/suffix'
import { registerPage } from '@/utils/register-page'

export const CloudValuePropContract = registerPage({
  shouldRenderFactory: () => import('./helpers/should-render'),
  pageFactory: () => import('./CloudValuePropPage'),
  suffix: PageSuffix.CLOUD_VALUE_PROP,
  analyticsConfig: () =>
    eventDispatcherConfig(false /* SFP as default in error cases */).config,
})
